module.exports = __webpack_public_path__ + "static/img/sm-bg.cdc3bd79.png";